export interface ProductSpec {
  icon: string;
  label: string;
  value: string;
}

export interface ProductData {
  id: string;
  slug: string;
  name: string;
  badge: string | null;
  image: string;
  images: string[];
  subtitle: string;
  description: string;
  specs: { potencia?: string; velocidade?: string; temperatura?: string; material?: string; [key: string]: string | undefined };
  fullSpecs: ProductSpec[];
  href: string;
  relatedSlugs: string[];
}

export const products: ProductData[] = [
  {
    id: 'bt950',
    slug: 'bt950',
    name: 'BT950',
    badge: 'Top Venda',
    image: 'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/8462c72463ed032b769bac2491845c56.png',
    images: [
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/8462c72463ed032b769bac2491845c56.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/bd99e483e393d3619d151a957710780a.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/7c1830bac36ee7c7da4bc9269b79c77e.jpeg',
    ],
    subtitle: 'Máquina de Solda Geomembrana de Alta Performance',
    description: 'O BT950 é o modelo mais avançado da linha SoldaGeo, projetado para projetos de grande escala que exigem máxima potência e precisão. Com 2100W e controle digital de temperatura, garante soldas perfeitas em geomembranas de até 3000 mic.',
    specs: { potencia: '2100w / 220v', velocidade: '5–8 m/min', temperatura: '0–500°C', material: '500–3000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2100w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '5–8 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–500°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–3000 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '11kg' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '40 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/bt950',
    relatedSlugs: ['bt1600', 'bt800', 'cx300-1400w'],
  },
  {
    id: 'bt1600',
    slug: 'bt1600',
    name: 'BT1600',
    badge: null,
    image: 'https://public.readdy.ai/ai/img_res/a4dda5f6-d8a8-4363-aceb-cc6ce6d0ce58.png',
    images: [
      'https://public.readdy.ai/ai/img_res/a4dda5f6-d8a8-4363-aceb-cc6ce6d0ce58.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/65dbfa36914ecb9a27b3b1a8e6c1e2e0.png',
    ],
    subtitle: 'Soldagem Profissional para Geomembrana',
    description: 'O BT1600 combina robustez e versatilidade para atender projetos de médio e grande porte. Com 1100W de potência e controle preciso de temperatura, é a escolha ideal para equipes que buscam produtividade e qualidade de solda consistente.',
    specs: { potencia: '1600w / 220v', velocidade: '5 m/min', temperatura: '0–450°C', material: '400–2000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1600w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '5 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–450°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '400–2000 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '4,2 kg' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '40 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/bt1600',
    relatedSlugs: ['bt950', 'bt800', 'cx300-1400w'],
  },
  {
    id: 'bt800',
    slug: 'bt800',
    name: 'BT800',
    badge: null,
    image: 'https://public.readdy.ai/ai/img_res/8c7ce478-561c-44a0-ad69-de8bab1cd873.png',
    images: [
      'https://public.readdy.ai/ai/img_res/8c7ce478-561c-44a0-ad69-de8bab1cd873.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/d7740c58fa872ca5ed11d8d1e192122d.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/3b910203674d525e9cd03045f9d9dbde.jpeg',
    ],
    subtitle: 'Compacto, Leve e Eficiente',
    description: 'O BT800 é a solução ideal para projetos de menor escala ou trabalhos em locais de difícil acesso. Com 800W e design compacto, oferece mobilidade sem abrir mão da qualidade de solda profissional.',
    specs: { potencia: '800w / 220v', velocidade: '2–5 m/min', temperatura: '0–400°C', material: '500–1500 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '800w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '2–5 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–400°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–1500 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '4.5 kg' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '30 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '12 meses' },
    ],
    href: '/produto/bt800',
    relatedSlugs: ['bt950', 'bt1600', 'cx300-1400w'],
  },
  {
    id: 'cx300-1400w',
    slug: 'cx300-1400w',
    name: 'CX300 1400W',
    badge: null,
    image: 'https://public.readdy.ai/ai/img_res/b2a7f8a3-6414-44f0-bc7d-f04b3bfc800c.png',
    images: [
      'https://public.readdy.ai/ai/img_res/b2a7f8a3-6414-44f0-bc7d-f04b3bfc800c.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/1e1eb9d0d33ec3626711ec51c7785ee3.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/da5f4b737cb665d7a1ae243fc6f96841.png',
    ],
    subtitle: 'Precisão Suíça para Geomembrana',
    description: 'A Weldy Mini Geo 2 é uma máquina de solda de cunha quente fabricada na Suíça, reconhecida mundialmente pela precisão e confiabilidade. Ideal para soldagem de geomembranas em projetos que exigem o mais alto padrão de qualidade.',
    specs: { potencia: '1400w / 220v', velocidade: '0,5–6 m/min', temperatura: '450°C', material: '500–1800 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1400w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '0,5–6 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura Máx.', value: '450°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–1800 mic' },
      { icon: 'ri-scales-line', label: 'Peso', value: '7 kg' },
      { icon: 'ri-global-line', label: 'Origem', value: 'china' },
      { icon: 'ri-ruler-line', label: 'Largura de Solda', value: '40 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '12 meses' },
    ],
    href: '/produto/cx300-1400w',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'ex3',
    slug: 'ex3',
    name: 'Extrusora EX3',
    badge: 'Extrusão',
    image: 'https://public.readdy.ai/ai/img_res/31b3cc2e-3832-4fee-a11b-ad416dc50f78.png',
    images: [
      'https://public.readdy.ai/ai/img_res/31b3cc2e-3832-4fee-a11b-ad416dc50f78.png',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/98ba7daf492cec8cf1fc1ff6d36b0add.jpeg',
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/55f613382979e92ea1217f67ff0f6b3a.jpeg',
    ],
    subtitle: 'Extrusora Profissional para Geomembrana',
    description: 'A Extrusora EX3 Weldy é a ferramenta definitiva para soldagem por extrusão de geomembranas espessas. Com temperatura de trabalho de até 700°C e produção de 3,5 kg/h, é indispensável em projetos que exigem soldas de alta resistência mecânica.',
    specs: { potencia: '3400w', velocidade: '3,5 kg/H', temperatura: '700°C', material: 'Ø 3,0–4,0 mm' },
    fullSpecs: [
      { icon: 'ri-speed-line', label: 'Produção', value: '3,5 kg/H' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura Máx.', value: '700°C' },
      { icon: 'ri-stack-line', label: 'Diâmetro do Fio', value: 'Ø 3,0–4,0 mm' },
      { icon: 'ri-plug-line', label: 'Tensão', value: '220V / 50-60Hz' },
      { icon: 'ri-scales-line', label: 'Peso', value: '5,2 kg' },
      { icon: 'ri-global-line', label: 'Origem', value: 'Suíça' },
      { icon: 'ri-tools-line', label: 'Tipo de Solda', value: 'Extrusão' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '12 meses' },
    ],
    href: '/produto/ex3',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'wgw300',
    slug: 'wgw300',
    name: 'Weldy WGW300',
    badge: null,
    image: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=768,fit=crop/A0xVvobDbRIBrVE7/weldy_wgw-300-removebg-preview-m7VKVpyzw7UEll8Y.png',
    images: [
      'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=768,fit=crop/A0xVvobDbRIBrVE7/weldy_wgw-300-removebg-preview-m7VKVpyzw7UEll8Y.png',
    ],
    subtitle: 'Alta Performance para Grandes Obras',
    description: 'O Weldy WGW300 é uma máquina de solda de cunha quente de alta performance, ideal para grandes obras de impermeabilização. Com 2100W e velocidade de até 9 m/min, garante produtividade máxima em campo.',
    specs: { potencia: '2100w / 220v', velocidade: '5–9 m/min', temperatura: '500°C', material: '500–3000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2100w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '5–9 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '500°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–3000 mic' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/wgw300',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'bt-gm1',
    slug: 'bt-gm1',
    name: 'BT-GM1',
    badge: 'Novo',
    image: 'https://public.readdy.ai/ai/img_res/9bdddc70-47f3-4acf-8891-5d37f9735472.png',
    images: [
      'https://public.readdy.ai/ai/img_res/9bdddc70-47f3-4acf-8891-5d37f9735472.png',
    ],
    subtitle: 'Novo Modelo de Alta Precisão',
    description: 'O BT-GM1 é o mais novo modelo da linha SoldaGeo, com controle digital avançado e alta precisão de soldagem. Projetado para atender projetos que exigem máxima confiabilidade e desempenho consistente.',
    specs: { potencia: '1800w / 220v', velocidade: '0.5–7 m/min', temperatura: '0–550°C', material: '500–2000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1800w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '0.5–7 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–550°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–2000 mic' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/bt-gm1',
    relatedSlugs: ['bt950', 'bt1600', 'bt800'],
  },
  {
    id: 'soprador-2000w-com-rolo',
    slug: 'soprador-2000w-com-rolo',
    name: 'Soprador 2000w com Rolo',
    badge: 'Acessório',
    image: 'https://public.readdy.ai/ai/img_res/b58c6ac0-4eb6-4d55-b57f-3a300ec56355.png',
    images: [
      'https://public.readdy.ai/ai/img_res/b58c6ac0-4eb6-4d55-b57f-3a300ec56355.png',
    ],
    subtitle: 'Soprador Profissional com Rolo de Pressão',
    description: 'O Soprador 2000W com Rolo é o acessório ideal para soldagem manual de geomembranas. Com temperatura de até 650°C e rolo de pressão integrado, garante soldas precisas e resistentes em qualquer condição.',
    specs: { potencia: '2000w / 220v', velocidade: 'Manual', temperatura: '0–650°C', material: '200–2000 mic' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2000w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: 'Manual' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–650°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '200–2000 mic' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/soprador-2000w-com-rolo',
    relatedSlugs: ['bt950', 'ex3', 'extrusora-weldy-booster-ex3-plus'],
  },
  {
    id: 'extrusora-metabo-bt610a',
    slug: 'extrusora-metabo-bt610a',
    name: 'Extrusora Metabo BT610A',
    badge: 'novo modelo',
    image: 'https://public.readdy.ai/ai/img_res/e28e6a3f-444f-4357-a287-6a98cb50ca63.png',
    images: [
      'https://public.readdy.ai/ai/img_res/e28e6a3f-444f-4357-a287-6a98cb50ca63.png',
    ],
    subtitle: 'Extrusora Metabo de Alta Potência',
    description: 'A Extrusora Metabo BT610A é o novo modelo de extrusora para soldagem de geomembranas espessas. Com 3400W de potência e temperatura de até 600°C, oferece alta produtividade e qualidade de solda superior.',
    specs: { potencia: '3400', velocidade: 'Manual', temperatura: '600', material: '3-4 mm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '3400W' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: 'Manual' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '600°C' },
      { icon: 'ri-stack-line', label: 'Diâmetro do Fio', value: '3-4 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/extrusora-metabo-bt610a',
    relatedSlugs: ['ex3', 'extrusora-weldy-booster-ex3-plus', 'bt950'],
  },
  {
    id: 'lc3000c',
    slug: 'lc3000c',
    name: 'LC3000C',
    badge: 'Profissional',
    image: 'https://public.readdy.ai/ai/img_res/4e1bfedb-dc31-4fa3-8bb5-765fc2850826.png',
    images: [
      'https://public.readdy.ai/ai/img_res/4e1bfedb-dc31-4fa3-8bb5-765fc2850826.png',
    ],
    subtitle: 'Máquina Profissional de Alta Durabilidade',
    description: 'A LC3000C é uma máquina de solda geomembrana profissional com alta durabilidade e desempenho consistente. Com 1800W e velocidade de até 7 m/min, é ideal para projetos de grande escala.',
    specs: { potencia: '1800w / 220v', velocidade: '3–7 m/min', temperatura: '0–600°C', material: '400–1100 µm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '1800w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '3–7 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–600°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '400–1100 µm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/lc3000c',
    relatedSlugs: ['bt950', 'bt1600', 'wgw300'],
  },
  {
    id: 'weldy-wgw300-plus',
    slug: 'weldy-wgw300-plus',
    name: 'Weldy WGW300',
    badge: 'Alta Velocidade',
    image: 'https://public.readdy.ai/ai/img_res/17b3c421-fd0b-4190-b248-c2f1bcd83fd5.png',
    images: [
      'https://public.readdy.ai/ai/img_res/17b3c421-fd0b-4190-b248-c2f1bcd83fd5.png',
    ],
    subtitle: 'Alta Velocidade para Grandes Projetos',
    description: 'Modelo de alta velocidade da linha Weldy WGW300, com 2000W e velocidade de até 8 m/min. Ideal para projetos de grande escala que exigem máxima produtividade.',
    specs: { potencia: '2000w / 220v', velocidade: '4–8 m/min', temperatura: '0–520°C', material: '500–3000 µm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '2000w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: '4–8 m/min' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–520°C' },
      { icon: 'ri-stack-line', label: 'Espessura do Material', value: '500–3000 µm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/weldy-wgw300-plus',
    relatedSlugs: ['bt950', 'wgw300', 'bt1600'],
  },
  {
    id: 'extrusora-weldy-booster-ex3-plus',
    slug: 'extrusora-weldy-booster-ex3-plus',
    name: 'Extrusora Weldy Booster EX3 Plus',
    badge: 'Acessório',
    image: 'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/b43c18507f9d89b05dd45bf61a730f66.png',
    images: [
      'https://static.readdy.ai/image/e1585ab442e0655c2e8a25da189d8509/b43c18507f9d89b05dd45bf61a730f66.png',
    ],
    subtitle: 'Extrusora Weldy Booster de Alta Performance',
    description: 'A Extrusora Weldy Booster EX3 Plus é a versão aprimorada da EX3, com maior potência e produtividade. Com 3400W e temperatura de até 600°C, é a escolha ideal para projetos que exigem soldas de alta resistência.',
    specs: { potencia: '3400w / 220v', velocidade: 'Manual', temperatura: '0–600°C', material: '3-4 mm' },
    fullSpecs: [
      { icon: 'ri-flashlight-line', label: 'Potência', value: '3400w / 220v' },
      { icon: 'ri-speed-line', label: 'Velocidade', value: 'Manual' },
      { icon: 'ri-temp-hot-line', label: 'Temperatura', value: '0–600°C' },
      { icon: 'ri-stack-line', label: 'Diâmetro do Fio', value: '3-4 mm' },
      { icon: 'ri-shield-check-line', label: 'Garantia', value: '6 meses' },
    ],
    href: '/produto/extrusora-weldy-booster-ex3-plus',
    relatedSlugs: ['ex3', 'extrusora-metabo-bt610a', 'bt950'],
  },
];
